import postHog from 'posthog-js';

export interface ErrorTrackingProperties {
  error_type: 'browser' | 'network' | 'backend';
  status_code?: number;
  request_url?: string;
  error_code?: string;
  additional_context?: Record<string, unknown>;
  [key: string]: unknown;
}

export const trackNetworkError = (
  error: Error,
  requestUrl?: string,
  additionalContext?: Record<string, unknown>
): void => {
  const properties: ErrorTrackingProperties = {
    error_type: 'network',
    request_url: requestUrl,
    additional_context: additionalContext
  };

  postHog.captureException(error, properties);
};

export const trackBackendError = (
  error: Error,
  statusCode?: number,
  requestUrl?: string,
  errorCode?: string,
  additionalContext?: Record<string, unknown>
): void => {
  const properties: ErrorTrackingProperties = {
    error_type: 'backend',
    status_code: statusCode,
    request_url: requestUrl,
    error_code: errorCode,
    additional_context: additionalContext
  };

  postHog.captureException(error, properties);
};
